import {getTokenCookie} from "../common"
import {getBaseDateList} from "../api"
import i18n from "../i18n"

export const loadBaseDate = async (group, term, code, cookies, dispatch) => {
  console.log(`loadBaseDate started: `, group, term, code)
  let value = [{ key: ``, label: `` }]

  if (group && term && code) {
    const params = { group, term, code }

    dispatch({
      type: `LOADING_MODAL`,
      loadingModal: {
        message: i18n.t(`loadingData`),
        state: true,
      },
    })

    const data = await getBaseDateList(getTokenCookie(cookies), params)
  
    dispatch({
      type: `LOADING_MODAL`,
      loadingModal: {
        state: false,
      },
    })

    if (data.length) {
      let dates = data.map((row) => row.baseDate.split(` `)[0])
      let list = Array.from(new Set(dates))
      value = list.map((d) => { return { key: d, label: d } })
    }
  }
  
  dispatch({
    type: `BASE_DATE_LIST`,
    baseDateList: value,
  })
  console.log(`loadBaseDate done.`)
}
